import Flickity from 'flickity';

const CLASS_NAME = '.js-carousel';
const defaultOptions = {
    adaptiveHeight: false,
    pageDots: true,
    prevNextButtons: false,
    cellAlign: 'left',
    wrapAround: true,
    cellSelector: '.carousel__item'
};

export default {
    init() {
        this._carouselElement = document.querySelector(CLASS_NAME);

        if (!this._carouselElement) {
            return;
        }

        this._create();
        this._initEventListeners();
    },

    _create() {
        const dataOptions = this._carouselElement.dataset;

        this.flkty = new Flickity(CLASS_NAME, Object.assign({}, defaultOptions, dataOptions));
    },

    _initEventListeners() {
        const nextButton = this._carouselElement.querySelector('.flickity-prev-next-button.next');

        if (!nextButton) {
            return;
        }

        nextButton.addEventListener('click', this._onNextClick.bind(this));
    },

    _onNextClick() {
        this.flkty.next();
    }
};
